export default __webpack_public_path__ + "ebbe817dc72ebe79335522ab1b269b58.svg";